import { gql } from '@apollo/client/core';
import { useLazyQuery } from '@vue/apollo-composable';

const LIST_WAIVERS = gql`
  query ListCourseOutstandingWaivers($filter: WaiverFilterInput, $first: Int!, $page: Int) {
    listCourseOutstandingWaivers(filter: $filter, first: $first, page: $page) {
      data {
        id
        student_id
        course_id
        academic_calendar_id
        reason
        student { id first_name surname matric_no }
        course { id course_code course_title unit }
        academicCalendar {
          id
          session { id name }
          termStructure { id name }
        }
        createdAt
      }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
        hasMorePages
      }
    }
  }
`;

export function useCourseOutstandingWaivers() {
  const page = ref(1);
  const first = ref(25);
  const filter = ref<Record<string, unknown>>({});

  const variables = computed(() => ({
    filter: filter.value,
    first: first.value,
    page: page.value,
  }));

  const { result, loading, refetch, load } = useLazyQuery(LIST_WAIVERS, variables);

  load();

  const waivers = computed(() => result.value?.listCourseOutstandingWaivers?.data ?? []);
  const paginatorInfo = computed(() => result.value?.listCourseOutstandingWaivers?.paginatorInfo ?? null);

  function setFilter(newFilter: Record<string, unknown>) {
    filter.value = { ...newFilter };
    page.value = 1;
    refetch();
  }

  function clearFilter() {
    filter.value = {};
    page.value = 1;
    refetch();
  }

  function setPage(newPage: number) {
    page.value = newPage;
    refetch();
  }

  return {
    waivers,
    paginatorInfo,
    loading,
    refetch,
    setFilter,
    clearFilter,
    setPage,
  };
}
